import { useState } from "react";
import { useToast } from "@/hooks/useToast";

interface DemoPlayerProps {
  poster: string;
  title: string;
  backdrop: string;
}

export default function DemoPlayer({ poster, title, backdrop }: DemoPlayerProps) {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [showNotice, setShowNotice] = useState(false);

  const handlePlay = () => {
    setLoading(true);
    setShowNotice(false);
    window.setTimeout(() => {
      setLoading(false);
      setShowNotice(true);
      showToast("演示演示：真实播放功能待接入", "ri-error-warning-line");
    }, 900);
  };

  return (
    <section className="overflow-hidden rounded-xl border border-background-800 bg-background-900">
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-background-800 px-5 py-4">
        <div className="flex items-center gap-2">
          <i className="ri-play-circle-line text-lg text-primary-400"></i>
          <h2 className="text-base font-semibold text-foreground-100 md:text-lg">在线观看演示区</h2>
        </div>
        <span className="rounded-full bg-accent-500/15 px-3 py-1 text-[11px] font-medium text-accent-400">
          演示演示，真实播放功能待接入
        </span>
      </div>

      <div className="relative w-full aspect-video bg-background-950">
        <img
          src={backdrop || poster}
          alt={`${title} 剧照`}
          title={`${title} 在线观看演示区`}
          className="h-full w-full object-cover object-top opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/50 to-background-950/40"></div>

        <div className="absolute inset-0 flex flex-col items-center justify-center px-4 text-center">
          {loading ? (
            <>
              <span className="h-12 w-12 animate-spin rounded-full border-2 border-background-600 border-t-primary-500"></span>
              <p className="mt-4 text-sm text-foreground-300">正在加载演示内容…</p>
            </>
          ) : showNotice ? (
            <>
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-800/90 text-accent-400">
                <i className="ri-error-warning-line text-2xl"></i>
              </span>
              <p className="mt-4 max-w-sm text-sm text-foreground-300">
                演示区域加载失败：本站暂未接入真实视频播放源，敬请期待。
              </p>
              <button
                type="button"
                onClick={handlePlay}
                className="mt-4 flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-600 px-4 py-2 text-sm text-foreground-200 transition-colors hover:border-primary-500 hover:text-primary-400"
              >
                <i className="ri-refresh-line"></i>
                重试
              </button>
            </>
          ) : (
            <button
              type="button"
              onClick={handlePlay}
              className="group flex flex-col items-center"
              aria-label="播放演示"
            >
              <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-500 text-background-950 transition-transform duration-300 group-hover:scale-110 md:h-20 md:w-20">
                <i className="ri-play-fill text-3xl md:text-4xl"></i>
              </span>
              <p className="mt-4 text-sm text-foreground-200 md:text-base">点击播放演示</p>
              <p className="mt-1 text-xs text-foreground-500">演示演示，真实播放功能待接入</p>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}